import { z } from 'zod';

export const MIN_PASSWORD_LENGTH = 8;

export const LowercaseRegex = /[\p{Ll}]/u;
export const UppercaseRegex = /[\p{Lu}]/u;
export const NumberRegex = /[\p{Nd}]/u;
export const SpecialCharacterRegex = /[^\p{L}\p{N}]/u; // not a letter or a number

export const PasswordSchema = z
  .string()
  .min(MIN_PASSWORD_LENGTH, { message: 'minLength' })
  .regex(LowercaseRegex, { message: 'lowercase' })
  .regex(UppercaseRegex, { message: 'uppercase' })
  .regex(NumberRegex, { message: 'number' })
  .regex(SpecialCharacterRegex, { message: 'specialCharacter' });

export type Password = z.infer<typeof PasswordSchema>;
